.panel {
	background: var(--surface-card);
	border-radius: var(--radius-lg);
	padding: var(--space-5);
	display: flex;
	flex-direction: column;
	gap: var(--space-4);
}

.heading {
	margin: 0;
	font-size: 1rem;
	font-weight: 600;
	color: var(--ink-muted);
	text-transform: uppercase;
	letter-spacing: 0.04em;
}

.list {
	list-style: none;
	margin: 0;
	padding: 0;
	display: flex;
	flex-direction: column;
	gap: var(--space-1);
	max-height: 50vh;
	overflow-y: auto;
}

.item {
	display: flex;
	align-items: center;
	gap: var(--space-3);
	width: 100%;
	border: none;
	background: transparent;
	padding: var(--space-2) var(--space-3);
	border-radius: var(--radius-sm);
	font: inherit;
	color: inherit;
	text-align: left;
	cursor: pointer;
}

.item:hover {
	background: var(--surface-input);
}

.selected {
	background: var(--surface-input);
	font-weight: 600;
}

.dot {
	width: 12px;
	height: 12px;
	border-radius: 50%;
	flex: none;
}

.form {
	display: flex;
	gap: var(--space-2);
}

.input {
	flex: 1;
	background: var(--surface-input);
	border: 1px solid var(--border);
	border-radius: var(--radius-sm);
	padding: var(--space-2) var(--space-3);
	font: inherit;
	color: inherit;
	outline: none;
}

.input:focus {
	border-color: var(--accent-sage);
}

.add {
	background: var(--accent-sage);
	color: #fff;
	border: none;
	border-radius: var(--radius-sm);
	padding: var(--space-2) var(--space-4);
	font: inherit;
	font-weight: 600;
	cursor: pointer;
}

.add:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}

.error {
	margin: 0;
	font-size: 0.875rem;
	color: var(--accent-rose);
}
